/**
 * AMOXTLI - Theme Context Provider
 * 
 * Propiedad Intelectual: Soluciones TecnoExpertas SAPI de CV
 * Autor: Luis Alberto Orozco Arias
 * Licencia: Propietaria - Todos los derechos reservados © 2026
 * 
 * Descripción: Context para gestionar temas globales de la aplicación
 */

import React, { createContext, useState, useEffect, useCallback, useMemo } from 'react'
import { themeService } from './themeService'

export const ThemeContext = createContext()

export function ThemeProvider({ children }) {
  const [currentTheme, setCurrentTheme] = useState(() => themeService.getCurrentTheme())
  const [currentThemeId, setCurrentThemeId] = useState(() => themeService.getCurrentThemeId())

  const switchTheme = useCallback((themeId) => {
    const theme = themeService.setTheme(themeId)
    setCurrentTheme(theme)
    setCurrentThemeId(themeId)
  }, [])

  const resetTheme = useCallback(() => {
    const theme = themeService.resetToDefault()
    setCurrentTheme(theme)
    setCurrentThemeId(themeService.getCurrentThemeId())
  }, [])

  const availableThemes = useMemo(() => themeService.getAvailableThemes(), [])

  return (
    <ThemeContext.Provider value={{
      theme: currentTheme,
      themeId: currentThemeId,
      switchTheme,
      resetTheme,
      availableThemes
    }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const context = React.useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme debe ser utilizado dentro de ThemeProvider')
  }
  return context
}
